import QR from './QR'

export default QR
